//@flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import { ButtonTypes, Button } from 'common/components/core/button';

import theme from './ExpanderArrow.scss';

type Props = {
    className?: string,
    theme: Object,
    isExpanded: boolean,
    disabled?: boolean
};

class ExpanderArrow extends React.PureComponent<Props> {
    render() {
        const { isExpanded, theme, disabled } = this.props;
        return (
            <Button
                ripple={false}
                disabled={disabled}
                buttonType={ButtonTypes.Icon}
                theme={theme}
                className={theme.expanderBtn}
                icon={isExpanded ? 'caret_down' : 'caret_right'}
            />
        );
    }
}
const ThemedExpanderArrow = themr('ExpanderArrow', theme)(ExpanderArrow);

export {
    ExpanderArrow as UnthemedExpanderArrow,
    ThemedExpanderArrow as ExpanderArrow
};
export default ThemedExpanderArrow;
